import { Navigate } from "react-router";
import { useAuth } from "../lib/auth";

export const Home = () => {
  const { status } = useAuth();
  if (status === "loading") return null;
  return <Navigate to={status === "authenticated" ? "/stores" : "/login"} replace />;
};
